<template>
  <base-page :back-to-i-e-p="true" :show-back-btn="true" :lock-viewport-scroll="true">
    <div class="home">
      <div class="card-view">
        <HomeHeader></HomeHeader>
        <div class="banner">
          <HomeBanner :imageList="imageList" @cDialog="handleDialog"></HomeBanner>
        </div>
        <UserMenu :new-version="newVersion" :notice_menu="notice_menu"></UserMenu>
      </div>
      <!-- <component :is="item" v-for="(item, index) in userComponents" :ref="item" :key="index"></component> -->
      <div class="answer-and-train">
        <div class="left">
          <div class="tab-icon-box" v-track="{functionName: '每日一题'}"
               @click="handleClick('dayAnswer', 'NOTICE_KEY_DAY_ANSWER')">
            <img src="@/assets/images/home/new-icon.png" alt="" v-if="isNewVersion('NOTICE_KEY_DAY_ANSWER')"
                 class="new-icon">
            <img src="../../assets/images/home/entrance/1.png" class="img-bg" alt="">
          </div>
          <div class="tab-icon-box" v-track="{functionName: '训练营'}"
               @click="handleClick('training', 'NOTICE_KEY_TRAINING')">
            <img src="@/assets/images/home/new-icon.png" alt="" v-if="isNewVersion('NOTICE_KEY_TRAINING')"
                 class="new-icon">
            <img src="../../assets/images/home/entrance/2.png" class="img-bg" alt="">
          </div>
        </div>
        <div class="right">
          <div class="tab-icon-box" v-track="{functionName: '室早心电图-点击入口'}"
               @click="handleClick('ecg', 'NOTICE_KEY_ECG')">
            <img src="@/assets/images/home/new-icon.png" alt="" v-if="isNewVersion('NOTICE_KEY_ECG')" class="new-icon">
            <img src="../../assets/images/home/entrance/3.png" class="img-bg" alt="">
          </div>
          <div class="tab-icon-box" v-track="{functionName: 'LAAC图书馆-点击入口'}"
               @click="handleClick('laac', 'NOTICE_KEY_LAAC')">
            <img src="@/assets/images/home/new-icon.png" alt="" v-if="isNewVersion('NOTICE_KEY_LAAC')" class="new-icon">
            <img src="../../assets/images/home/entrance/4.png" class="img-bg" alt="">
          </div>
        </div>
      </div>
      <!-- 地图、科室总览整合 -->
      <LearnDptTab></LearnDptTab>
      <!-- 直播、信息提示 -->
      <Live></Live>
      <!-- 推荐 -->
      <recommend></recommend>
      <JourneyUpdatePopup :isShow="isShowJourneyUpdatePopup" :updatePopupInfo="updatePopupInfo"
                          @closePopup="closeJourneyUpdatePopup"></JourneyUpdatePopup>
      <StageUpdatePopup :isShow="isShowStageUpdatePopup" :updatePopupInfo="updatePopupInfo"
                        @closePopup="closeStageUpdatePopup"></StageUpdatePopup>
      <AnnualReportPopup
        v-model="showAnnualReportPopup"
        @close="handleAnnualPopupClose"
        @confirm="handleAnnualPopupConfirm"
      />
      <barComponents></barComponents>
      <questionnaire-dialog ref="QuestionnaireDialog" v-model="isShowQuestionnaireDialog"></questionnaire-dialog>
      <course-tip-dialog ref="CourseTipDialog" v-model="isShowCourseTipDialog"></course-tip-dialog>
      <MedalPopup
        v-model="showMedalPopup"
        @close="handleMedalPopupClose"
      />
      <!--病例评鉴，弹窗-->
      <CaseReviewPosterPopup
        v-model="showCaseReviewPosterPopup"
        :poster-url="caseReviewBatch && caseReviewBatch.posterUrl"
        @close="handleCaseReviewPosterClose"
        @confirm="handleCaseReviewPosterConfirm"
      />
    </div>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog && cDialog.content }}</div>
    </custom-dialog>
  </base-page>
</template>

<script>
import {mapGetters} from 'vuex'
import BasePage from '@/components/BasePage.vue'
import UserMenu from '@/components/UserMenu.vue'
import HomeBanner from './components/HomeBanner.vue'
import HomeHeader from './components/HomeHeader.vue'
import JourneyUpdatePopup from './components/JourneyUpdatePopup.vue'
import StageUpdatePopup from './components/StageUpdatePopup.vue'
import LearnDptTab from './components/LearnDptTab.vue'
import Live from './components/Live.vue'
import barComponents from '../../components/barComponents.vue'
import recommend from './components/recommend.vue'
import {getBanner, getJourneyUpdateData, modifyPopupState} from '@/api/api'
import {
  BOOL_EMPLOYEE,
  BOOL_GOAL,
  BOOL_NON_EP,
  BOOL_NON_GOAL,
  BOOL_SENIOR,
  BOOL_SENIOR_EMPLOYEE
} from '@/utils/configRoles'
import {iepUserInterestTag} from '@/api/person'
import withRouteTracking from '@/utils/withRouteTracking'
import QuestionnaireDialog from './components/QuestionnaireDialog.vue'
import CourseTipDialog from './components/CourseTipDialog.vue'
import {getSurveyShowUserId} from '../../api/questionnaire'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import {getRemindBool, getRemindObj, postRemind, postRemindObj} from '../../api/simulator'
import {getUserIdentity} from '../../utils/util'
import {dictionaryList, getServerTime} from '../../api/api'
import {handleTraceFunction} from '../../utils/trace'
import AnnualReportPopup from './components/AnnualReportPopup.vue'
import MedalPopup from './components/MedalPopup.vue'
import CaseReviewPosterPopup from './components/CaseReviewPosterPopup.vue'
import {isAnnualReportLive} from '@/utils/annualReport'
import {getMyActiveBatches} from '@/api/caseReview'

const UserProfile = {
  name: 'home',
  components: {
    CustomDialog,
    BasePage,
    UserMenu,
    HomeBanner,
    HomeHeader,
    JourneyUpdatePopup,
    StageUpdatePopup,
    AnnualReportPopup,
    MedalPopup,
    CaseReviewPosterPopup,
    LearnDptTab,
    Live,
    barComponents,
    recommend,
    QuestionnaireDialog,
    CourseTipDialog
  },
  computed: {
    ...mapGetters(['userComponents']), // 动态菜单以及组件
    userInfo() {
      return this.$store.getters.userInfo
    },
    isNewVersion() {
      return (code) => {
        return this.newVersion.find(a => a.code === code)
      }
    },
  },
  data() {
    return {
      notice_menu: [],
      newVersion: [],
      userIdentity: getUserIdentity(),
      imageList: [],
      updatePopupInfo: {},
      isShowJourneyUpdatePopup: false,
      isShowStageUpdatePopup: false,
      isShowQuestionnaireDialog: false,
      isShowCourseTipDialog: false,
      showAnnualReportPopup: false,
      showMedalPopup: false,
      showCaseReviewPosterPopup: false,
      caseReviewBatch: null,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '',
        cancel: () => {
          this.cDialog.visible = false
        },
        confirm: () => {
          this.cDialog.visible = false
        },
        close: () => {
          this.cDialog.visible = false
        }
      },
    }
  },
  async created() {
    await this.getDictionaryList()
    await this.checkAllVersionChanges()
  },
  async mounted() {
    this.getBannerList()
    await this.getCourseTipDialog()
    await this.getSurvey()
    await this.initAnnualReportEntry()
    await this.initCaseReviewPosterEntry()
    await this.checkContestComplete()
    await this.checkContestRemind()
    sessionStorage.removeItem('isShare')
    sessionStorage.removeItem('searchParams')
    window.sessionStorage.setItem('entrance', '1')
    await this.getIepUserInterestTag()
    await this.getJourneyUpdateInfo()
    this.$nextTick(() => {
      if (this.$refs.GrowthJourney) {
        if (this.$refs.GrowthJourney[0] && this.$refs.GrowthJourney[0].$refs.growthJourney) {
          this.$refs.GrowthJourney[0].$refs.growthJourney.$data.curPageTitle = '员工首页'
        }
      }
    })
    if (BOOL_EMPLOYEE) {
      window.sessionStorage.setItem('traceTitle', '员工首页')
    } else if (BOOL_NON_GOAL) {
      window.sessionStorage.setItem('traceTitle', '非目标EP术者首页')
    } else if (BOOL_GOAL) {
      window.sessionStorage.setItem('traceTitle', '目标EP术者首页')
    } else if (BOOL_NON_EP) {
      window.sessionStorage.setItem('traceTitle', 'non-ep首页')
    } else if (BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE) {
      window.sessionStorage.setItem('traceTitle', '大主任首页')
    }
  },
  methods: {
    async initAnnualReportEntry() {
      if (this.isShowCourseTipDialog || this.isShowQuestionnaireDialog) return

      // 检查年度报告是否在活动时间
      const annualReportReady = await isAnnualReportLive()

      // 年报弹窗需要检测时间，只在活动期间显示
      if (annualReportReady) {
        this.showAnnualReportPopup = await this.fetchAnnualReportRemindStatus()
      } else {
        this.showAnnualReportPopup = false
      }

      // 徽章弹窗不需要检测时间，如果不显示年报弹窗，就检查徽章弹窗
      if (!this.showAnnualReportPopup) {
        this.showMedalPopup = await this.fetchMedalPopupStatus()
      } else {
        this.showMedalPopup = false
      }
    },
    /** 医鉴批次海报弹窗：取进行中批次里最新一条未读 */
    async initCaseReviewPosterEntry () {
      if (this.isShowCourseTipDialog || this.isShowQuestionnaireDialog) return
      if (this.showAnnualReportPopup || this.showMedalPopup) return
      if (!this.userInfo || !this.userInfo.id) return

      try {
        const { data } = await getMyActiveBatches()
        const latestBatch = (data || [])[0]
        if (latestBatch && latestBatch.viewed === false) {
          this.caseReviewBatch = latestBatch
          this.showCaseReviewPosterPopup = true
        }
      } catch (error) {
        console.error('获取进行中医鉴批次失败:', error)
      }
    },
    /** 记录医鉴批次海报已读 */
    async recordCaseReviewPosterRead () {
      if (!this.userInfo || !this.userInfo.id || !this.caseReviewBatch) return
      try {
        await postRemind({
          readType: `CaseReviewPoster_${this.caseReviewBatch.batchId}`,
          readTypeName: '医鉴批次海报已读',
          iepUserId: this.userInfo.id
        })
      } catch (error) {
        console.error('记录医鉴批次海报已读失败:', error)
      }
    },
    // 关闭-病例评鉴-弹窗
    handleCaseReviewPosterClose () {
      this.showCaseReviewPosterPopup = false
    },
    // 点击确定按钮-病例评鉴-弹窗
    async handleCaseReviewPosterConfirm () {
      await this.recordCaseReviewPosterRead()
      this.showCaseReviewPosterPopup = false
      this.$router.push({
        path: '/caseReview',
        query: {
          entrance: '166',
          channel: '166'
        }
      })
    },
    async handleAnnualPopupConfirm() {
      handleTraceFunction({functionName: '2025年度报告弹窗提醒', functionUrl: `${process.env.baseURL}${process.env.BASE_URL}/annualReport?entrance=102&channel=102`, createTime: new Date().getTime()})
      await this.recordAnnualReportReminder()
      const entrance = '102'
      this.$router.push({
        path: '/annualReport',
        query: {
          entrance,
          channel: entrance
        }
      })
    },
    async handleAnnualPopupClose() {
      await this.recordAnnualReportReminder()
      this.showAnnualReportPopup = false
    },
    async fetchAnnualReportRemindStatus() {
      if (!this.userInfo || !this.userInfo.id) return false
      try {
        const res = await getRemindBool({
          userId: this.userInfo.id,
          readType: '2025AnnualReportPopup'
        })
        return res.code === 0 ? !res.data : false
      } catch (error) {
        console.error('获取年度报告提醒状态失败:', error)
        return false
      }
    },
    async recordAnnualReportReminder() {
      if (!this.userInfo || !this.userInfo.id) return
      try {
        await postRemind({
          readType: '2025AnnualReportPopup',
          readTypeName: '2025年度报告弹窗',
          iepUserId: this.userInfo.id
        })
      } catch (error) {
        console.error('记录年度报告弹窗状态失败:', error)
      }
    },
    async fetchMedalPopupStatus() {
      if (!this.userInfo || !this.userInfo.id) return false
      try {
        // 检查用户是否已生成海报
        const posterRes = await getRemindBool({
          userId: this.userInfo.id,
          readType: '2025AnnualReportPosterGenerated'
        })
        const hasPoster = posterRes.code === 0 && posterRes.data

        // 如果没有生成海报，不显示徽章弹窗
        if (!hasPoster) return false

        // 检查用户是否已看过徽章弹窗
        const medalRes = await getRemindBool({
          userId: this.userInfo.id,
          readType: '2025AnnualReportMedalPopup'
        })
        return medalRes.code === 0 ? !medalRes.data : false
      } catch (error) {
        console.error('获取徽章弹窗状态失败:', error)
        return false
      }
    },
    async recordMedalPopupShown() {
      if (!this.userInfo || !this.userInfo.id) return
      try {
        await postRemind({
          readType: '2025AnnualReportMedalPopup',
          readTypeName: '2025年度报告徽章弹窗',
          iepUserId: this.userInfo.id
        })
      } catch (error) {
        console.error('记录徽章弹窗状态失败:', error)
      }
    },
    async checkAllVersionChanges() {
      for (const item of this.notice_menu) {
        if (item.value) {
          try {
            const res = await getRemindBool({
              userId: this.userInfo.id,
              readType: item.value
            })
            if (res.code === 0 && !res.data) {
              this.newVersion.push(item)
            }
          } catch (error) {
            console.error('检查版本变更失败:', error)
          }
        }
      }
    },
    async getDictionaryList() {
      let params = {
        typeCodeList: ['VERSION'],
        dataStatus: '1'
      }
      const res = await dictionaryList(params)
      if (res.code === 0) {
        this.notice_menu = res.data
      }
    },
    handleDialog({visible, title, content}) {
      this.cDialog.visible = visible
      this.cDialog.title = title
      this.cDialog.content = content
    },
    async getCourseTipDialog() {
      const res = await getRemindBool({userId: this.userInfo.id, readType: 'NewCourseFrameworkGuide'})
      if (res.code === 0) {
        if (!res.data) {
          this.isShowCourseTipDialog = true
        } else {
          this.isShowCourseTipDialog = false
        }
      }
    },
    async handlePostRemind(versionCode) {
      const a = this.newVersion.find(a => a.code === versionCode)
      if (!a) return
      await postRemind(
        {
          'readType': a.value,
          'readTypeName': '版本更新',
          'iepUserId': this.userInfo.id
        }
      )
    },
    async handleClick(type, versionCode) {
      if (type === 'ecg') {
        if (this.userIdentity.veevaStatus === '待验证' && this.userIdentity.isDueDate) {
          this.cDialog.visible = true
          this.cDialog.title = '提示'
          this.cDialog.content = '敬请期待!'
          return
        }
      }
      await this.handlePostRemind(versionCode)
      switch (type) {
        case 'training':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/trainingList`)
          this.$router.push({
            path: '/trainingList'
          })
          break
        case 'dayAnswer':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/questionIndex`)
          this.$router.push({
            path: '/questionIndex'
          })
          break
        case 'ecg':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/JJMC_ECGenius`)
          this.$router.push({
            path: '/JJMC_ECGenius',
            query: {
              entrance: '1',
              channel: '1'
            }
          })
          break
        case 'laac':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/laac`)
          this.$router.push({
            path: '/laac',
          })
          break
      }
    },
    async getSurvey() {
      if (this.isShowCourseTipDialog) return
      const nextTalk = sessionStorage.getItem('nextTalk')
      if (nextTalk && nextTalk === 'true') {
        this.isShowQuestionnaireDialog = false
        return
      }
      try {
        const res = await getSurveyShowUserId(this.userInfo.id)
        if (res.code === 0 && res.data && res.data.length) {
          this.isShowQuestionnaireDialog = true
          this.$refs.QuestionnaireDialog.init(res.data)
          return
        }
        this.isShowQuestionnaireDialog = false
      } catch (e) {
        console.log('err', e)
        throw e
      }
    },
    async getIepUserInterestTag() {
      const res = await iepUserInterestTag({iepUserId: this.userInfo.id})
      if (res.data.length <= 0 && !sessionStorage.getItem('interest') && this.userInfo.entryMark === 1) {
        this.$router.push({
          path: '/person/interest'
        })
      }
    },
    // 获取轮播图
    async getBannerList() {
      let params = {
        pageNum: '1',
        pageSize: '10',
        multiCode: this.userInfo.multiCode || '',
        module: 'HEADER'
      }
      const res = await getBanner(params)
      if (res && res.code === 0 && res.data) {
        const batchRes = await getMyActiveBatches().catch(() => ({}))
        const hasActiveCaseReview = ((batchRes.data) || []).length > 0
        this.imageList = res.data.filter(item => !(item.linkUrl && item.linkUrl.includes('caseReview')) || hasActiveCaseReview)
      }
    },
    // 获取升级弹窗
    async getJourneyUpdateInfo() {
      if (this.isShowCourseTipDialog || this.isShowQuestionnaireDialog ||
          this.showAnnualReportPopup || this.showMedalPopup || this.showCaseReviewPosterPopup) return
      let multiCode = this.userInfo.multiCode
      // let multiCode = 'MULD100125997'
      if (multiCode === undefined || multiCode === null || multiCode === '') {
        return
      }
      let params = {
        multiCode: multiCode
        // multiCode: 'MULD10000231277'
      }
      const res = await getJourneyUpdateData(params)
      if (res && res.data) {
        // 测试数据
        // let obj = {
        //   createTime: '1680226762000',
        //   currentJourney: '超声视界之旅',
        //   currentLevel: 'A+',
        //   currentStage: '超声精准房间隔穿刺',
        //   isPoppedUp: 'false',
        //   multiCode: 'MULD100000977',
        //   name: '张志军',
        //   oldJourney: '超声视界之旅',
        //   oldLevel: 'A+',
        //   oldStage: '超声精准房间隔穿刺',
        //   oldStageDisplayName: '',
        //   stageDisplayName: 'A2-超声指导下精准房间隔穿刺',
        //   updateTime: '1680229028000'
        // }
        // this.updatePopupInfo = JSON.parse(JSON.stringify(obj))
        this.updatePopupInfo = JSON.parse(JSON.stringify(res.data))
        // 判断是否弹过窗
        // isPoppedUp:true 已弹过
        // isPoppedUp:false 未弹过
        if (this.updatePopupInfo.isPoppedUp === 'false' && this.updatePopupInfo.oldJourney && this.updatePopupInfo.oldStage) {
          // 判断弹出窗口
          if (this.updatePopupInfo.currentJourney !== this.updatePopupInfo.oldJourney) {
            // 旅程弹窗
            this.isShowJourneyUpdatePopup = true
            this.isShowStageUpdatePopup = false
            this.updatePopupInfo.lastJourney = false
          } else if (this.updatePopupInfo.currentStage !== this.updatePopupInfo.oldStage) {
            // 阶段升级弹窗
            this.isShowJourneyUpdatePopup = false
            this.isShowStageUpdatePopup = true
            this.updatePopupInfo.lastJourney = false
          } else if (this.updatePopupInfo.currentJourney === '超声视界之旅' &&
            this.updatePopupInfo.oldJourney === '超声视界之旅' &&
            this.updatePopupInfo.currentStage === '超声精准房间隔穿刺' &&
            this.updatePopupInfo.oldStage === '超声精准房间隔穿刺') {
            // 旅程弹窗
            this.isShowJourneyUpdatePopup = true
            this.isShowStageUpdatePopup = false
            this.updatePopupInfo.lastJourney = true
          }
        } else {
          this.isShowJourneyUpdatePopup = false
          this.isShowStageUpdatePopup = false
          this.updatePopupInfo.lastJourney = false
        }
      }
    },
    changePopupState() {
      let multiCode = this.userInfo.multiCode || ''
      // let multiCode = 'MULD10000305473'
      let params = {
        multiCode: multiCode
        // multiCode: 'MULD10000231277'
      }
      modifyPopupState(params).then(res => {
      })
    },
    closeJourneyUpdatePopup() {
      // this.changePopupState()
      this.isShowJourneyUpdatePopup = false
    },
    closeStageUpdatePopup() {
      // this.changePopupState()
      this.isShowStageUpdatePopup = false
    },
    // 检查竞赛是否完成 完成给出弹窗
    async checkContestComplete() {
      // 员工不弹窗（memberType === 0 表示术者）
      if (this.userInfo.memberType !== 0) return

      // 如果有其他弹窗正在显示，则不弹出
      if (this.isShowCourseTipDialog || this.isShowQuestionnaireDialog ||
          this.showAnnualReportPopup || this.showMedalPopup || this.showCaseReviewPosterPopup ||
          this.isShowJourneyUpdatePopup || this.isShowStageUpdatePopup) return

      const contestTypes = [
        { type: 'QingfengExam', name: '青锋赛' },
        { type: 'ZhengbaExam', name: '争霸赛' },
        { type: 'HaixuanExam', name: '第十二届"好术者"首届左心耳封堵赛线上海选赛' },
      ]

      for (const contest of contestTypes) {
        try {
          const res = await getRemindObj({
            userId: this.userInfo.id,
            readType: contest.type
          })
          // applyReason 为 0 表示已完成但未提醒，null 表示未完成
          if (res.code === 0 && res.data !== null && res.data.applyReason === '0') {
            // 显示完成弹窗
            await this.$tipsDialog.alert({
              message: `恭喜您完成了"好术者"线上海选赛-${contest.name}，系统将奖励您20积分哦！`,
              confirmButtonText: '我知道了',
            })
            // 记录已提醒，设置 applyReason 为 1
            await postRemindObj({
              readType: contest.type,
              readTypeName: '竞赛完成提醒',
              id: res.data.id,
              iepUserId: this.userInfo.id,
              applyReason: '1'
            })
          }
        } catch (error) {
          console.error(`检查${contest.name}完成状态失败:`, error)
        }
      }
    },
    async checkContestTime() {
      // 1. 获取服务器时间
      const now = await getServerTime()
      const currentDate = new Date(now)

      // 2. 获取竞赛时间配置
      const { code, data } = await dictionaryList({
        typeCode: 'ACTIVITY_POPUP_TYPE',
        dataStatus: '1'
      })

      if (code !== 0 || !data || !data.length) {
        // 接口异常或无数据，直接视为不在竞赛期
        return false
      }

      let config
      try {
        config = JSON.parse(data[0].explainContent)
      } catch (e) {
        return false
      }

      const { startTime, endTime } = config
      if (!startTime || !endTime) return false

      // 3. 显式构造 Date，避免时区歧义
      const contestStartDate = new Date(`${startTime} 00:00:00`)
      const contestEndDate = new Date(`${endTime} 23:59:59`)
      // 4. 时间判断
      return currentDate >= contestStartDate && currentDate <= contestEndDate
    },
    // 检查竞赛开赛提醒弹窗
    async checkContestRemind() {
      // 员工不弹窗（memberType === 0 表示术者）
      if (this.userInfo.memberType !== 0) return

      // 如果有其他弹窗正在显示，则不弹出
      if (this.isShowCourseTipDialog || this.isShowQuestionnaireDialog ||
          this.showAnnualReportPopup || this.showMedalPopup || this.showCaseReviewPosterPopup ||
          this.isShowJourneyUpdatePopup || this.isShowStageUpdatePopup) return

      const isInContestTime = await this.checkContestTime()
      if (!isInContestTime) return

      try {
        const res = await getRemindBool({
          userId: this.userInfo.id,
          readType: 'contestStartRemind2026'
        })
        if (res.code === 0 && !res.data) {
          // 未提醒过，显示弹窗
          const iconUrl = require('@/assets/images/popUpNotificationIcon1.png')
          const iconUrl2 = require('@/assets/images/gift.png')
          const iconUrl3 = require('@/assets/images/contest/time.png')
          const iconUrl4 = require('@/assets/images/popUpNotificationIcon2.png')
          this.$tipsDialog.alert({
            message: `
            <div class="color-black-80 f-w-bold m-b-18">【第十二届"好术者"线上海选赛】热血开闸!</div>
            <div class="color-black-80 f-w-400 m-b-22">"好术者比赛"--心电生理青年术者专属舞台，权威专家全程点评指导!</div>
            <div class="m-b-8"><img src="${iconUrl}" class="remind-icon m-r-4"/>双赛道同步燃爆！</div>
            <div class="color-black-80 f-w-400 m-b-6"><span class="f-w-800">青锋赛道:</span>非房颤独立术者，32席直通线下!</div>
            <div class="color-black-80 f-w-400 m-b-30"><span class="f-w-800">争霸赛道:</span>房颤独立术者，抢32席荣耀!</div>
            <div class="f-s-14 color-black-80 f-w-400">
            <div class="m-b-6"><img src="${iconUrl3}" class="remind-icon m-r-4"/><span>海选赛时间:2026.2.1-2.28</div>
            <div class="m-b-6 d-f"><img src="${iconUrl2}" class="remind-icon m-r-4"/><span>参赛即领iEP 20积分，平台精选课程随心兑!</span></div>
            <div><img src="${iconUrl4}" class="remind-icon m-r-4"/>首页点击「好术者」Banner，一键开战!</div>
            </div>
            `,
            confirmButtonText: '我知道了',
            messageStyle: {
              textAlign: 'left',
              padding: '14px 14px 27px'
            },
            decorationImage: require('@/assets/images/decorationImage.png'),
          }).then(() => {
            handleTraceFunction({functionName: `竞赛开赛弹窗提醒`, createTime: new Date().getTime()})
            // 记录已提醒
            postRemind({
              readType: 'contestStartRemind2026',
              readTypeName: '竞赛开赛提醒',
              iepUserId: this.userInfo.id
            })
          }).catch(() => {})
        }
      } catch (error) {
        console.error('检查竞赛提醒失败:', error)
      }
    },
    async handleMedalPopupClose() {
      await this.recordMedalPopupShown()
      this.showMedalPopup = false
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style scoped lang="less">
.home {
  background-color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  // overflow: hidden;
  padding-bottom: 60px;
  box-sizing: border-box;
}

.menu-item {
  font-size: 12px;

  img {
    width: 44px;
    height: 44px;
  }
}

.answer-and-train {
  display: grid;
  padding: 0 16px;
  margin-bottom: 10px;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;

  .tab-icon-box {
    position: relative;

    .new-icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 22px;
    }
  }

  .img-bg {
    width: 100%;
  }
}

.card-view {
  width: 100%;
  // background-color: #f0f1f6;
  background-color: #ffffff;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0px 0px 12px 12px;

  .banner {
    position: relative;
    width: 351px;
    height: 158px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue